import React from 'react'

const CalculatorColumn = (props) => {
    const style = {
        alignSelf: props.alignSelf,
        flexBasis: props.flexBasis,
        textAlign: props.textAlign,
        paddingBottom: props.paddingBottom,
    }
    
    return (
        <div className='calculator-box__column' style={style}>
            {props.children}
        </div>
    )
}

export default CalculatorColumn